import React, {useEffect, useMemo, useState} from 'react';
import {Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import {Input, Select} from "../../../../_metronic/_partials/controls";
import {Field} from "formik";
import {chargeWallet} from "../../Auth/_redux/authCrud";

export function ChargeWalletDialog({
    show,
    onHide
                                   }) {

    const [selectedBranch, setSelectedBranch] = useState("");
    const [amount, setAmount] = useState("0");

    const user = useSelector(
        (state) => state.auth.user
    );

    const branches = useMemo(() => {
        return user.branches.map(b => {
            return {
               id: b.id,
               name: b.name,
            }
        })
    }, [])

    const onSubmit = async () => {
        if(selectedBranch === "")
            alert("لطفا شعبه را انتخاب کنید");

        const result = await chargeWallet({
            branchId: selectedBranch,
            amount: +amount,
        })
        const token = result.data.token;
        window.location.href = `https://sep.shaparak.ir/OnlinePG/SendToken?token=${token}`;
    }

    return (
        <Modal onHide={onHide} show={show}>
            <Modal.Header closeButton>
                شارژ کیف پول
            </Modal.Header>
            <Modal.Body>
                <form className={"form form-label-right"}>
                    <div className={"form-group row px-4"}>
                        <div className={"col-lg-12 mb-1"}>
                            <label>شعبه</label>
                            <select
                                onChange={(e) => setSelectedBranch(e.target.value)}
                                name={"branchId"}
                                className={'form-control form-control-solid'}
                            >
                                <option value={""}>لطفا یک شعبه را انتخاب کنید</option>
                                {branches && branches.map(branch => (
                                    <option key={branch.id} value={branch.id}>
                                        {branch.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className={"col-lg-12 mb-1"}>
                            <label>مبلغ واریزی</label>
                            <input type={"text"} className={"form-control"} value={amount} onChange={(e) => setAmount(e.target.value)} />
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <button
                        className={'btn btn-light btn-elevate'}
                        onClick={onHide}>
                        لغو
                    </button>
                    <button
                        onClick={onSubmit}
                        className={'btn btn-primary btn-elevate'}
                        >
                        شارژ کیف پول
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}